import { useContext } from 'react'

import { BreakpointContext } from '@core/components/Layout/Breakpoint/BreakpointContext'
import { getActiveBreakpoint } from '@core/components/Layout/Breakpoint/helpers'

/**
 * @brief This hook can be used to retrieve the breakpoint information from the BreakpointContext.
 * @returns {object} height, width, activeBreakpoint, sourceOfTruth - Information about the breakpoint.
 * @usage const {height, width, activeBreakpoint, sourceOfTruth} = useBreakpoint()
 */
export const useBreakpoint = () => {
  const currentBreakpointContext = useContext(BreakpointContext)

  if (!currentBreakpointContext) {
    throw new Error(
      'useBreakpoint has to be used within <BreakpointContext.Provider>',
    )
  }

  const { height, width, provider } = currentBreakpointContext

  return {
    height,
    width,
    activeBreakpoint: getActiveBreakpoint(width),
    provider,
  }
}
